export const FETCH_MAINPOPUP_LIST = 'FETCH_MAINPOPUP_LIST';